/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentRunsWakeAgentRun } from "../../funcs/agentRunsWakeAgentRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.WakeAgentRunRequest$inboundSchema,
};

export const tool$agentRunsWakeAgentRun: ToolDefinition<typeof args> = {
  name: "agent-runs-wake-agent-run",
  description: `Wake a sleeping agent run

Interrupts a short sleep tool call on a background run by forwarding follow-up input to the gateway response.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentRunsWakeAgentRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
